import React from 'react'
import clsx from 'clsx'
import { Switch as MuiSwitch } from '@mui/material'

import useStyles from './styles'

const Switch = ({ className = '', checked, disabled = false, ...props }) => {
  const classes = useStyles()

  return (
    <MuiSwitch
      checked={checked}
      disabled={disabled}
      {...props}
      className={clsx(
        classes.root,
        {
          [classes.checked]: checked,
          [classes.disabled]: disabled,
          [classes.off]: disabled && !checked
        },
        className
      )}
    />
  )
}

export default Switch
